/*
 * Utilities
 */
function findClosestParentOfType(el, nodeName) {
    let parentNode = el.parentNode;
    while (parentNode && parentNode.nodeName !== nodeName) {
        parentNode = parentNode.parentNode;
    }
    return parentNode;
}

async function calculateMinimumWidthOfInputToFitText(input, textToFit) {
    await document.fonts.ready;

    const styles = window.getComputedStyle(input);
    const inlinePadding = parseInt(styles.paddingLeft) + parseInt(styles.paddingRight) + parseInt(styles.borderLeftWidth) + parseInt(styles.borderRightWidth);
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    context.font = styles.font;
    context.letterSpacing = styles.letterSpacing;
    const width = context.measureText(textToFit).width;

    return Math.ceil(width + inlinePadding) + "px";
}

function afterNextDomRepaint() {
    return new Promise((resolve) => {
        // requestAnimationFrame fires before next repaint
        // so if we request it twice, we will have gone through one repaint
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                resolve();
            });
        });
    });
}
function isPagePreview() {
    // window.parent because the actual page is embedded here
    const pathArray = window.parent.location.pathname.split("/");
    const result = pathArray[1] === 'umbraco' && pathArray[2] === 'preview';

    return result
}

